import { createElement } from 'react';
import './index.scss';
import { convertChildren } from "../../utils/children-node-handle";
var Status;
(function (Status) {
    Status[Status["undone"] = 0] = "undone";
    Status[Status["complete"] = 1] = "complete";
})(Status || (Status = {}));
const IntegralTask = ({ list, icon, images, undoneLabel, completeLabel, children, ...otherProps }) => {
    console.log(images, 'images');
    images = images || [];
    return (createElement("div", { className: "integral-task__container", ...otherProps }, list && list.length ? list.map((item, index) => {
        return (createElement("div", { className: "integral-task__container__item" },
            createElement("div", { className: "integral-task__container__item__left" },
                convertChildren(children, 'image-left', {
                    src: images[index % images.length],
                    className: 'integral-task__container__item__left__img'
                }),
                createElement("div", { className: "integral-task__container__item__left__content" },
                    convertChildren(children, 'title', {
                        children: item.name,
                        className: 'integral-task__container__item__left__content__title'
                    }),
                    createElement("div", { className: "integral-task__container__item__left__content__integral" },
                        icon ? convertChildren(children, 'image-icon', {
                            src: icon,
                            className: 'integral-task__container__item__left__content__integral--icon'
                        }) : '',
                        convertChildren(children, 'integral', {
                            children: item.integral + ' 积分',
                            className: 'integral-task__container__item__left__content__integral--number'
                        })))),
            createElement("div", { className: "integral-task__container__item__right" }, convertChildren(children, 'button2', {
                children: item.integral + ' 积分',
                name: item.status === Status.undone ? undoneLabel : completeLabel,
                color: Status[item.status]
            }))));
    }) : '暂无数据'));
};
export default IntegralTask;
